import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const FormatTab = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.50923 3.13379H3.22223L3.22223 5.05972H2.22223V3.13379V2.13379H13.7778V3.13379H13.8316V5.05972H12.8316V3.13379H8.50923L8.50923 13.2171H10.3611V14.2171H8.50923V14.2223H7.50923V14.2171H5.6389V13.2171H7.50923L7.50923 3.13379Z"
        fill={color}
      />
    </svg>
  )
})

export default FormatTab
